import React from 'react';
import { LazyPersonalizedSectionFetcher, Placeholder } from '@fiverr-private/personalized_content';
import { PERSONALIZED_CONTENT } from '../../../utils/constants/recommendations';
import { useTranslationContext } from '../../../context/TranslationContext';

const PersonalizedSection = ({
    recommendationsParams,
}: {
    recommendationsParams: {
        browse_history: string[];
        pageName: string;
        funnelName: string;
    };
}) => {
    const { personalizedContentMap, setOriginalContent, showTranslatedContent } = useTranslationContext();

    const placeholder = <Placeholder.GigsSectionPlaceholder />;

    const getPersonalizedContent = () => {
        if (showTranslatedContent) {
            return personalizedContentMap?.translated;
        }
        if (personalizedContentMap?.original) {
            return personalizedContentMap?.original;
        }

        return undefined;
    };

    return (
        <LazyPersonalizedSectionFetcher
            sectionName={PERSONALIZED_CONTENT.SECTION_NAME}
            placeholder={placeholder}
            personalizedContent={getPersonalizedContent()}
            useV5Routes={true}
            className="revamp-personalized-section"
            onFetchSucceeded={setOriginalContent}
            showTranslatedUGC={showTranslatedContent}
            recommendationsParams={recommendationsParams}
            fallback={<Placeholder.GigsSectionPlaceholder />}
        />
    );
};

export default PersonalizedSection;
